module.exports = __webpack_public_path__ + "static/img/pop_up.5dc07f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/collection/pop_up.png
// module id = 9Agn
// module chunks = 4